(() => {
  const root = document.querySelector('.home-carousel');
  if (!root) return;
  const track = root.querySelector('.home-track');
  const slides = [...root.querySelectorAll('.home-slide')];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let current = 0, timer, hovered = false, touch = null;
  function stop() { clearInterval(timer); }
  function start() {
    stop();
    const keyboardFocus = root.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
    if (slides.length > 1 && !hovered && !touch && !document.hidden && !reducedMotion.matches && !keyboardFocus)
      timer = setInterval(() => show(current + 1), 5500);
  }
  function show(index) {
    current = (index + slides.length) % slides.length;
    track.style.transform = `translateX(-${current * 100}%)`;
    slides.forEach((slide, i) => {
      slide.inert = i !== current;
      slide.setAttribute('aria-hidden', String(i !== current));
    });
  }
  root.querySelector('.home-arrow--prev').addEventListener('click', () => { show(current - 1); start(); });
  root.querySelector('.home-arrow--next').addEventListener('click', () => { show(current + 1); start(); });
  root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' || event.pointerType === 'pen') { hovered = true; stop(); } });
  root.addEventListener('pointerleave', () => { hovered = false; start(); });
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', () => setTimeout(start, 0));
  root.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1)); start();
    }
  });
  root.addEventListener('touchstart', event => { touch = [event.touches[0].clientX, event.touches[0].clientY]; stop(); }, {passive:true});
  root.addEventListener('touchend', event => {
    if (touch) {
      const dx = event.changedTouches[0].clientX - touch[0], dy = event.changedTouches[0].clientY - touch[1];
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
    }
    touch = null; start();
  }, {passive:true});
  root.addEventListener('touchcancel', () => { touch = null; start(); }, {passive:true});
  document.addEventListener('visibilitychange', start);
  reducedMotion.addEventListener('change', start);
  show(0); start();
})();
